import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-785ccf0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-cookie-block" }
const _hoisted_2 = { class: "modal-cookie-block_header" }
const _hoisted_3 = {
  key: 0,
  class: "modal-cookie-block_icon -append",
  width: "29",
  height: "29",
  viewBox: "0 0 29 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_6399_14005)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.25 13.25V7C13.25 6.44772 13.6977 6 14.25 6H14.6667C15.219 6 15.6667 6.44772 15.6667 7V13.25H21.9167C22.469 13.25 22.9167 13.6977 22.9167 14.25V14.6667C22.9167 15.219 22.469 15.6667 21.9167 15.6667H15.6667V21.9167C15.6667 22.469 15.219 22.9167 14.6667 22.9167H14.25C13.6977 22.9167 13.25 22.469 13.25 21.9167V15.6667H7C6.44772 15.6667 6 15.219 6 14.6667V14.25C6 13.6977 6.44772 13.25 7 13.25H13.25Z",
    fill: "#203454"
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_6399_14005" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "29",
      height: "29",
      fill: "white"
    })
  ])
], -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "modal-cookie-block_icon -append",
  width: "29",
  height: "29",
  viewBox: "0 0 29 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_6420_7574)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.292 13.292H15.7087H21.9587C22.5109 13.292 22.9587 13.7397 22.9587 14.292V14.7087C22.9587 15.2609 22.5109 15.7087 21.9587 15.7087H15.7087H13.292H7.04199C6.48971 15.7087 6.04199 15.2609 6.04199 14.7087V14.292C6.04199 13.7397 6.48971 13.292 7.04199 13.292H13.292Z",
    fill: "#203454"
  })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_6420_7574" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "29",
      height: "29",
      fill: "white"
    })
  ])
], -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "18",
  viewBox: "0 0 14 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.59392 8.31818H9.66294V6.27273C9.66294 5.51989 9.41543 4.87713 8.92041 4.34446C8.42539 3.81179 7.82806 3.54545 7.12843 3.54545C6.4288 3.54545 5.83147 3.81179 5.33645 4.34446C4.84143 4.87713 4.59392 5.51989 4.59392 6.27273V8.31818ZM12.8311 9.34091V15.4773C12.8311 15.7614 12.7387 16.0028 12.5539 16.2017C12.3691 16.4006 12.1446 16.5 11.8806 16.5H2.37622C2.11221 16.5 1.8878 16.4006 1.70299 16.2017C1.51819 16.0028 1.42578 15.7614 1.42578 15.4773V9.34091C1.42578 9.05682 1.51819 8.81534 1.70299 8.61648C1.8878 8.41761 2.11221 8.31818 2.37622 8.31818H2.69304V6.27273C2.69304 4.96591 3.12866 3.84375 3.99989 2.90625C4.87113 1.96875 5.91398 1.5 7.12843 1.5C8.34288 1.5 9.38573 1.96875 10.257 2.90625C11.1282 3.84375 11.5638 4.96591 11.5638 6.27273V8.31818H11.8806C12.1446 8.31818 12.3691 8.41761 12.5539 8.61648C12.7387 8.81534 12.8311 9.05682 12.8311 9.34091Z",
    fill: "#51DA3B"
  })
], -1))
const _hoisted_12 = { class: "modal-cookie-block_body" }
const _hoisted_13 = {
  key: 0,
  class: ""
}
const _hoisted_14 = { class: "modal-cookie-block_hidden" }
const _hoisted_15 = { class: "item_row" }
const _hoisted_16 = { class: "item_title" }
const _hoisted_17 = { class: "item_desc" }
const _hoisted_18 = {
  key: 0,
  class: "item_row"
}
const _hoisted_19 = { class: "item_title" }
const _hoisted_20 = { class: "item_desc" }
const _hoisted_21 = { class: "item_row" }
const _hoisted_22 = { class: "item_title" }
const _hoisted_23 = { class: "item_desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ac_switch = _resolveComponent("ac-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "modal-cookie-block_title",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleBlock && _ctx.toggleBlock(...args)))
      }, [
        (!_ctx.showBlock)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_6))
          : (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_10)),
        _createTextVNode(" " + _toDisplayString(_ctx.cookie.title), 1)
      ]),
      _createVNode(_component_ac_switch, {
        "model-value": _ctx.cookie.enabled,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleCookie(_ctx.cookie.key)))
      }, _createSlots({ _: 2 }, [
        (_ctx.cookie.key === 'essential')
          ? {
              name: "icon",
              fn: _withCtx(() => [
                _hoisted_11
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["model-value"])
    ]),
    _createElementVNode("div", _hoisted_12, [
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Разнообразный и богатый опыт постоянный количественный рост и сфера нашей активности представляет собой интересный эксперимент проверки модели развития. Таким образом постоянный количественный рост. "))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_14, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cookie.items, (item, key) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `modal-cookie-block_item-${key}`,
            class: "modal-cookie-block_item item"
          }, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('cookie.name')), 1),
              _createElementVNode("div", _hoisted_17, _toDisplayString(item.names.join(', ')), 1)
            ]),
            (item.type)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('cookie.type')), 1),
                  _createElementVNode("div", _hoisted_20, _toDisplayString(item.type), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('cookie.description')), 1),
              _createElementVNode("div", _hoisted_23, _toDisplayString(item.title), 1)
            ])
          ]))
        }), 128))
      ], 512), [
        [_vShow, _ctx.showBlock]
      ])
    ])
  ]))
}